import script from "./OptionQuotes.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionQuotes.vue?vue&type=script&setup=true&lang=js"

import "./OptionQuotes.vue?vue&type=style&index=0&id=4e8ab448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8ab448"]])

export default __exports__